import React, { Fragment } from "react";
import { DropLi, formatDate, useFormatPrice } from "hooks";

const PrintRegCloseSummary = ({ data, txns, totals }) => {
  const formatPrice = useFormatPrice();
  const { TxnTypes } = DropLi();
  const primaryColor = "#5b648f";

  const compBodyCls = {
    display: "grid",
    gap: "10px",
    border: "1px solid #ddd",
    borderRadius: "20px",
  };

  const detailsSectCls = {
    padding: "10px 15px 10px 15px",
    display: "flex",
    justifyContent: "space-between",
  };

  const titleCls = {
    fontSize: "20px",
    fontWeight: "500",
    padding: "10px 10px 5px 10px",
    borderBottom: "1px solid #ddd",
    textTransform: "uppercase",
  };

  const labelCompCls = {
    display: "grid",
  };

  const labelSubtextCls = {
    fontSize: "10px",
    marginBottom: "7px",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    color: "#808080",
  };

  const thCls = {
    textAlign: "right",
    padding: "5px 10px",
    textTransform: "uppercase",
    fontSize: "14px",
    color: primaryColor,
    letterSpacing: "0.5px",
  };

  const tdCls = {
    textAlign: "right",
    padding: "8px 10px",
    fontSize: "16px",
  };

  return (
    <div
      style={{
        marginBottom: "20px",
        fontFamily: "Arial, sans-serif",
        display: "grid",
        gap: "20px",
      }}
    >
      {/* Details */}
      <div style={compBodyCls}>
        <span style={titleCls}>Register Details</span>

        {/* Details */}
        <div style={detailsSectCls}>
          <div style={labelCompCls}>
            <span style={labelSubtextCls}>Outlet</span>
            <span
              style={{
                fontSize: "14px",
              }}
            >
              {data.outlet && data.outlet.outletName}
            </span>
          </div>
          <div style={labelCompCls}>
            <span style={labelSubtextCls}>Register</span>
            <span
              style={{
                fontSize: "14px",
              }}
            >
              {data.register && data.register.name}
            </span>
          </div>
          <div style={labelCompCls}>
            <span style={labelSubtextCls}>Opening Time</span>
            <span
              style={{
                fontSize: "14px",
              }}
            >
              {formatDate(data?.openingTime)}
            </span>
          </div>
          <div style={labelCompCls}>
            <span style={labelSubtextCls}>Closing Time</span>
            <span
              style={{
                fontSize: "14px",
              }}
            >
              {formatDate(data?.closingTime)}
            </span>
          </div>
        </div>
      </div>

      {/* Payment Summary */}
      {data.sellRegPayments && (
        <div style={compBodyCls}>
          <span style={titleCls}>Payment Summary</span>

          {/* Details */}
          <div style={{ ...detailsSectCls, padding: "0px" }}>
            <table
              style={{
                width: "100%",
                marginTop: "20px",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr style={{ borderBottom: "1px solid #ddd" }}>
                  <th style={{ ...thCls, textAlign: "left" }}>
                    Payment Method
                  </th>
                  <th style={thCls}>Expected</th>
                  <th style={thCls}>Counted</th>
                  <th style={thCls}>Differences</th>
                </tr>
              </thead>
              {/* Table Body */}
              <tbody>
                {data.sellRegPayments.map((payment, ind) => {
                  return (
                    <Fragment key={ind}>
                      <tr style={{ borderBottom: "1px solid #ddd" }}>
                        <td style={{ ...tdCls, textAlign: "left" }}>
                          {payment.payType && payment.payType.name}
                        </td>
                        <td style={tdCls}>{formatPrice(payment.expected)}</td>
                        <td style={tdCls}>{formatPrice(payment.counted)}</td>
                        <td style={tdCls}>
                          {formatPrice(payment.differences)}
                        </td>
                      </tr>

                      {/* Cash Movements */}
                      {/* Heading */}
                      {payment.payTypeId === 1 &&
                        payment.payType &&
                        payment.payType.name === "Cash" && (
                          <>
                            {/* Cash Movement Header */}
                            <tr>
                              <td
                                style={{
                                  fontSize: "18px",
                                  padding: "10px 10px 5px 10px",
                                  color: primaryColor,
                                }}
                              >
                                Cash Movements
                              </td>
                              <td
                                style={{
                                  padding: "10px 10px 0px 0px",
                                  borderBottom: "1px solid #ddd",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "20px",
                                    justifyContent: "space-between",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    letterSpacing: "0.5px",
                                    color: "#737373",
                                  }}
                                >
                                  <div style={{ display: "flex", gap: "12px" }}>
                                    <span style={{ minWidth: "80px" }}>
                                      Time
                                    </span>
                                    <span>User</span>
                                  </div>
                                  <span>Amount</span>
                                </div>
                              </td>
                              <td
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                  color: "#737373",
                                  padding: "10px 10px 0px 15px",
                                  borderBottom: "1px solid #ddd",
                                }}
                              >
                                Reason
                              </td>
                              <td
                                style={{ borderBottom: "1px solid #ddd" }}
                              ></td>
                            </tr>

                            {/* Cash movements records  */}
                            {txns &&
                              txns.map((txn, ind) => {
                                var txnType = TxnTypes.find(
                                  (j) => j.id === txn.txnType
                                );
                                var txnTypeName = txnType ? txnType.label : "";
                                return (
                                  <tr key={ind + "cash_movement"}>
                                    <td></td>
                                    <td
                                      style={{
                                        padding: "10px 10px 5px 0px",
                                        borderBottom: "1px solid #ddd",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "20px",
                                          justifyContent: "space-between",
                                          fontSize: "12px",
                                          letterSpacing: "0.5px",
                                          color: "#737373",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "12px",
                                          }}
                                        >
                                          <span style={{ minWidth: "80px" }}>
                                            {formatDate(txn.txnDate)}
                                          </span>
                                          <span>{txn?.user?.fullName}</span>
                                        </div>
                                        <span>{formatPrice(txn.amount)}</span>
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        padding: "10px 10px 0px 15px",
                                        borderBottom: "1px solid #ddd",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "grid",
                                          gap: "2px",
                                          paddingBottom: "2px",
                                          maxWidth: "350px",
                                          fontSize: "14px",
                                          color: "#737373",
                                        }}
                                      >
                                        <span>{txnTypeName}</span>
                                        <span style={{ fontSize: "10px" }}>
                                          {txn.note}
                                        </span>
                                      </div>
                                    </td>
                                    <td
                                      style={{ borderBottom: "1px solid #ddd" }}
                                    ></td>
                                  </tr>
                                );
                              })}

                            {/* Cash Received */}
                            <tr
                              style={{
                                borderBottom: "1px solid #ddd",
                                borderTop: "1px solid #ddd",
                              }}
                            >
                              <td
                                style={{
                                  fontSize: "18px",
                                  padding: "10px",
                                  color: primaryColor,
                                }}
                              >
                                Cash Payment Received
                              </td>
                              <td style={tdCls}>
                                {formatPrice(data.cashMovement)}
                              </td>
                            </tr>
                          </>
                        )}
                    </Fragment>
                  );
                })}

                {/* Total */}
                <tr>
                  <td
                    style={{
                      ...tdCls,
                      textAlign: "left",
                      textTransform: "uppercase",
                      fontWeight: "bold",
                      color: "#737373",
                      letterSpacing: "1px",
                    }}
                  >
                    Total
                  </td>
                  <td style={{ ...tdCls, fontWeight: "bold" }}>
                    {formatPrice(totals.expected)}
                  </td>
                  <td style={{ ...tdCls, fontWeight: "bold" }}>
                    {formatPrice(totals.counted)}
                  </td>
                  <td style={{ ...tdCls, fontWeight: "bold" }}>
                    {formatPrice(totals.differences)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrintRegCloseSummary;
